import React from "react";
import { Link } from "react-router-dom";

const Navbar = ({ setShow, size }) => {
  return (
    <div className="panel is-link">
        <p className="panel-heading">ADD CONTRACT</p>
        <div className="panel-tabs p-2">
            <div className="buttons has-addons">
              <Link to="/contracts" className="button has-text-weight-semibold is-small is-info is-outlined">
                <span className="is-size-6">Cancel</span>                
              </Link>
              
              <button className="button has-text-weight-semibold is-small is-info is-outlined" onClick={() => setShow(true)}>
                <span className="is-size-6">Show Product List</span>
              </button>
              <button className="button has-text-weight-semibold is-small is-info is-outlined" onClick={() => setShow(false)}>
                <span className="is-size-6">Show Form Contract<span className="ml-1 has-text-weight-bold">({size})</span></span>
              </button>              
            </div>           
        </div>
    </div>
  );
};

export default Navbar;